import { useQuery } from '@tanstack/react-query';
import React, { useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { destroySession } from '../../helpers/Session';
import axios from '../../api/axios';

const ReportDepartments = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');

    const { data: departments, isLoading: isLoadingDepartments, error: errorDepartments } = useQuery({
        queryKey: ['departments'],
        queryFn: async () => {
            const res = await axios.get('departments', {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        }
    });

    useEffect(() => {
        if (errorDepartments) {
            if (errorDepartments.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorDepartments]);

    const handleSetReportsDepartmentData = (slug, department) => {
        sessionStorage.setItem('reportsDepartment', department);
        sessionStorage.setItem('reportsDepartmentSlug', slug);
    }

    return (
        <div className='departments'>
            <div className="page-header">
                <div className='title'>
                    <h1>Reports</h1>
                    <ul className='breadcrumbs'>
                        <li><NavLink to='/reports'>Reports</NavLink></li>
                        <li>Departments</li>
                    </ul>
                </div>
            </div>

            <div className='panels'>
                <div className='panel'>
                    <div className='content'>
                        <div className={`card ${isLoadingDepartments && ' loading'}`}>
                            {
                                isLoadingDepartments ? (
                                    [...Array(8)].map((_, i) => (
                                        <div key={i} className="card-content">
                                            <a>
                                                <i className="fa fa-folder"></i>
                                                <span>Resty Alejo</span>
                                            </a>
                                        </div>
                                    ))
                                ) : (
                                    departments?.map((item) => (
                                        <div key={item.id} className="card-content">
                                            <NavLink to={`/reports/${item.slug}`} title={item.department} onClick={() => { handleSetReportsDepartmentData(item.slug, item.department); }}>
                                                <i className="fa fa-folder"></i>
                                                <span>{item.department}</span>
                                            </NavLink>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReportDepartments;